import KardiaRxCCTEcgTable from './KardiaRxCCTEcgTable';

export default KardiaRxCCTEcgTable;



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTEcgTable/index.js